import React, { useEffect, useState } from "react";
import axios from "../../utils/axios";

export default function FloatingEditButtons() {
  const [buttons, setButtons] = useState([]);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`/admin/floatbuttons`)
      .then((res) => {
        if (mounted && Array.isArray(res.data)) setButtons(res.data);
      })
      .catch(() => {});
    return () => (mounted = false);
  }, []);

  if (!buttons || buttons.length === 0) return null;

  return (
    <div className="fixed right-6 bottom-6 z-50 flex flex-col gap-3">
      {buttons.map((b) => (
        <a
          key={b.id}
          href={b.link}
          title={b.title || "Edit"}
          className="w-12 h-12 rounded-full shadow-lg bg-white flex items-center justify-center border"
        >
          <img src={b.img} alt={b.title || "btn"} className="w-8 h-8 object-contain" />
        </a>
      ))}
    </div>
  );
}
